import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Button, SelectField, FlexRow, NumberField } from 'ui-toolkit';
import { payerTypeOptions } from '../../../../../types/order/escrow/ePayerType';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { depositCategoryOptions } from '../../../../../types/order/escrow/eDepositCategory';
import { useHasPermissions } from '../../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

export interface ICreateEditWireDisbursementRowProps {
  index: number;
  onDelete: (index: number) => void;
  fieldName: string;
}

export const CreateEditWireDepositRow: React.FC<ICreateEditWireDisbursementRowProps> = ({
  index,
  onDelete,
  fieldName,
}) => {
  const hasEditPermission = useHasPermissions([ePermissions.EscrowExpectedIncomingWiresEdit]);

  return (
    <>
      <Grid>
        <Grid columnCount={4} alignItems={`center`}>
          <NumberField
            name={`${fieldName}.${index}.amountCents`}
            label="Amount"
            mode="currency"
            placeholder="123,456.78"
            valueIsCents
            disabled={!hasEditPermission}
          />
          <SelectField
            name={`${fieldName}.${index}.payerType`}
            options={payerTypeOptions}
            label={'Payer Type'}
            isDisabled={!hasEditPermission}
          />
          <SelectField
            name={`${fieldName}.${index}.category`}
            options={depositCategoryOptions}
            label={'Category'}
            isDisabled={!hasEditPermission}
          />
          <FlexRow justifyContent={'start'} verticalAlign={'center'}>
            <Button
              intent={'ghost'}
              isInline
              type={'button'}
              onClick={() => onDelete(index)}
              disabled={!hasEditPermission}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Button>
          </FlexRow>
        </Grid>
      </Grid>
    </>
  );
};
